import { AGENDA } from "@/constants/summit";
import { Reveal, SectionHeading } from "@/components/Reveal";

const Agenda = () => (
  <section id="agenda" data-testid="agenda-section" className="relative py-24 sm:py-32 bg-charcoal/40">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <SectionHeading index="05" kicker="Summit Agenda" title="One day. Precision engineered." />
      <div className="mt-14 max-w-4xl">
        {AGENDA.map((a, i) => (
          <Reveal key={a.time} delay={i * 0.04}>
            <div className="group flex flex-col gap-1 border-t border-white/10 py-6 transition-colors duration-500 hover:border-brand-500/40 sm:flex-row sm:items-baseline sm:gap-10">
              <span className="w-24 shrink-0 font-mono text-sm font-semibold text-brand-400">{a.time}</span>
              <div>
                <h3 className="font-display text-lg sm:text-xl font-semibold transition-colors duration-300 group-hover:text-brand-300">
                  {a.title}
                </h3>
                <p className="mt-1 text-sm text-white/50">{a.detail}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Agenda;
